import React, { Fragment, useState } from 'react';
import { Card, Button } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CategoryLayouts from '../../../../../../data/CategoryLayouts';
import CategoryTag from './CategoryTag';
export default function CategoryList({ item, allAddonCategoryData, languageCode, LoadData, propertyId }) {
    const [isUpdating, setIsUpdating] = useState(false);
    return (
        <Fragment>
            <Colxx xxs="12">
                <Card className="d-flex flex-row mb-3">
                    <div className="pl-2 d-flex flex-grow-1 min-width-zero col-12">
                        <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                            <p className="mb-1 text-small w-50 w-sm-100">
                                <b>{item.title}</b>
                            </p>
                            <p className="mb-1 text-small w-50 w-sm-100">
                                <b>{CategoryLayouts.filter((p) => p.value === item.layout).map(k => k.label)}</b>
                            </p>
                            <div className="w-15 w-sm-100">
                                <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => setIsUpdating(!isUpdating)}
                                >
                                    Edit
                                </Button>
                            </div>
                        </div>
                    </div>
                </Card>
            </Colxx>
            {isUpdating && (
                <CategoryTag
                    visible={isUpdating}
                    toggle={() => setIsUpdating(!isUpdating)}
                    allCategoryData={allAddonCategoryData}
                    isEdit={isUpdating}
                    propertyId={propertyId}
                    LoadData={LoadData}
                    languageCode={languageCode}
                    categoryId={item.id}
                ></CategoryTag>
            )}
        </Fragment>
    );

}